<template>
  <div
    v-if="numberOfNotifications > 0"
    class="absolute inline-block cursor-pointer select-none bg-red-700 text-xs leading-none text-white"
    style="top: 0px; right: -10px; padding: 1px 5px; border-radius: 50%"
  >
    {{ numberOfNotifications }}
  </div>
</template>

<script>
export default {
  props: {
    numberOfNotifications: {
      type: Number,
      default: 0,
    },
  },
};
</script>
